import React from "react";
import { AlertTriangle, CircleAlert } from "lucide-react";
import { cn } from "@/lib/utils";
import { PinnedRuleDiagnostic } from "@/lib/conflictRuleDiagnostics";

/** The server's findings about one part of a rule: errors stop a preview, a run and a save; warnings never do. */
const RuleDiagnosticList: React.FC<{ diagnostics: PinnedRuleDiagnostic[]; className?: string }> = ({
  diagnostics,
  className,
}) =>
  diagnostics.length === 0 ? null : (
    <ul className={cn("flex flex-col gap-0.5", className)}>
      {diagnostics.map((diagnostic, index) => (
        <li
          key={`${diagnostic.pointer}-${index}`}
          role={diagnostic.severity === "error" ? "alert" : undefined}
          className={cn(
            "flex items-start gap-1 text-xs",
            diagnostic.severity === "error" ? "text-destructive" : "text-amber-600 dark:text-amber-400"
          )}
        >
          {diagnostic.severity === "error" ? (
            <CircleAlert className="mt-0.5 size-3.5 shrink-0" />
          ) : (
            <AlertTriangle className="mt-0.5 size-3.5 shrink-0" />
          )}
          <span className="min-w-0 break-words">{diagnostic.message}</span>
        </li>
      ))}
    </ul>
  );

export default RuleDiagnosticList;
